// extracted by mini-css-extract-plugin
export default {"wrapper":"dYlFabZMMb0f1jWPNAP0","label":"qYgP1d1ZMdZXQGFWkfQ3","checkbox":"FN9IJva0CCQcPYnvnJN1","checked":"HBhjbVVwy0lV6wWP0zaU"};